import { ChangeEvent, CSSProperties } from 'react';
import classnames from 'classnames/bind';

import styles from './index.module.sass';

interface radioProps {
  isChecked: boolean;
  id: string;
  value?: string;
  name?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  style?: CSSProperties;
}

const Radio = ({
  isChecked = false,
  id,
  value,
  name,
  disabled,
  onChange,
  style,
}: radioProps) => {
  const cx = classnames.bind(styles);

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(event.target.value);
  };

  const radioClass = cx({
    radio: true,
    disabled: disabled,
  });

  return (
    <label className={radioClass} style={style}>
      <input
        id={id}
        value={id}
        name={name}
        checked={isChecked}
        type="radio"
        onChange={onChangeHandler}
        disabled={disabled}
      />
      {value && <span>{value}</span>}
    </label>
  );
};

export default Radio;
